<div class="container-fluid mt-3 ">
    <div class="row">
        <mat-form-field class="col-12">
            <mat-label>Code</mat-label>
            <input matInput [(ngModel)]="Model.Code" placeholder="Code" disabled>
        </mat-form-field>
        <mat-form-field class="col-12">
            <mat-label>Heure de prélèvement</mat-label>
           <input matInput placeholder="Heure de prélèvement" [ngxTimepicker]="timepicker" [value]="samplingTime" [format]="24" readonly>
            <ngx-material-timepicker #timepicker (timeSet)="timeSetSamplingDate($event)"></ngx-material-timepicker>

        </mat-form-field>
        <mat-form-field class="col-12">
            <mat-label>Localisation</mat-label>
            <input matInput [(ngModel)]="Model.Localisation" placeholder="Localisation">
        </mat-form-field>
    </div>
    @if (Model.MaterielEau) {
    <div class="row">
        <mat-form-field class="col-12">
            <mat-label>Date de changement du filtre</mat-label>
            <input matInput placeholder="Date de changement du filtre" [matDatepicker]="picker" [(ngModel)]="DateChangementFiltre" (click)="picker.open()" (dateChange)="dateChangementFiltreChanged($event)">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="col-12">
            <mat-label>Référence</mat-label>
            <input matInput [(ngModel)]="Model.MaterielEau.Reference" placeholder="Référence">
        </mat-form-field>
        <!-- <mat-form-field class="col-12">
            <mat-label>Référence Etiquette</mat-label>
            <input matInput [(ngModel)]="Model.ReferenceEtiquette" placeholder="Référence Etiquette">
        </mat-form-field> -->
        <mat-form-field class="col-12">
            <mat-label>Nombre de douche</mat-label>
            <input matInput [(ngModel)]="Model.MaterielEau.NombreDouche" type="number" placeholder="Nombre de douche">
        </mat-form-field>
        <mat-form-field class="col-12">
            <mat-label>Matériau</mat-label>
            <input matInput [(ngModel)]="Model.MaterielEau.Materiau" placeholder="Matériau">
        </mat-form-field>
        <mat-form-field class="col-12">
            <mat-label>Localisation du rejet</mat-label>
            <mat-select placeholder="Localisation du rejet" [(ngModel)]="Model.MaterielEau.LocalisationRejet" required>
                @for (o of LocalisationRejetList; track o; let i = $index) {
                <mat-option [value]="i + 1">
                    <span>{{o}}</span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
        <mat-form-field class="col-12">
            <mat-label>Type de matériel</mat-label>
            <mat-select placeholder="Type de matériel" [(ngModel)]="Model.MaterielEau.Type" required>
                @for (o of TypeMaterielList; track o; let i = $index) {
                <mat-option [value]="i + 1">
                    <span>{{o}}</span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
        <mat-slide-toggle class="my-auto h-100" labelPosition="after" [(ngModel)]="Model.TakeAnotherDay">
            Récupérer la MEST un autre jour
        </mat-slide-toggle>
    </div>
    }
    <div class="row my-3">
        <button appPreventDoubleClick class="col" color="warn" mat-raised-button (throttledClick)="cancelMeasure()">
            Mesure non réalisée
        </button>
    </div>
    <div class="row">
        <button appPreventDoubleClick class="col" color="primary" mat-raised-button (throttledClick)="save()">
            Enregistrer
        </button>
    </div>
</div>